<template>
  <div class="layers">
      <el-table
        :data="getAllLayers"
        :cell-style="{ 'color': '#000000' }"
        :show-header="false"
        border
        >
        <el-table-column
          prop="name"
          show-overflow-tooltip
          label="名称">
        </el-table-column>
        <el-table-column
          prop="isOff"
          show-overflow-tooltip
          label="数量"
          align="right">
          <template v-slot="{ row, $index }">
            <img :src=" row.isOff ? require('@/assets/img/measure/eye.svg')
            : require('@/assets/img/measure/eye_checked.svg')"
              @click="handleClick(row, $index)">
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
  data () {
    return {
      layers: []
    }
  },
  computed: {
    getAllLayers () {
      const allChecked = this.layers.every(item => !item.isOff)
      return [{ name: '全部图层', isOff: !allChecked }, ...this.layers]
    },
    cadVersion () {
      return this.$store.state.cadVersion || ''
    }
  },
  watch: {
    cadVersion () {
      this.getLayers()
    }
  },
  created () {
  },
  mounted () {
    this.getLayers()
  },
  methods: {
    handleClick (row, index) {
      if (index === 0) {
        this.layers.forEach(item => {
          item.isOff = !row.isOff
        })
      } else {
        this.layers[index - 1].isOff = !row.isOff
      }
      this.doSwitchLayer()
    },
    doSwitchLayer () {
      this._map.switchLayers(this._map.getService(), this.getVisibleLayer())
    },
    getVisibleLayer () {
      return this.layers.reduce((sum, val) => {
        if (!val.isOff) {
          sum.push(val.name)
        }
        return sum
      }, [])
    },
    // 递归获取图层
    getLayers () {
      setTimeout(() => {
        const mapRef = this.$parent.$parent.$parent.$children[0].$children[0]
        const svc = mapRef._svc
        if (svc) {
          this._map = mapRef._map
          // 获取所有图层
          const layers = svc.getMapLayers()
          this.layers = layers
        } else {
          this.getLayers()
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table__row{
    &:nth-child(1){
      background-color: #F5F5F5;
      color: #000000;
      font-weight: 600;
    }
    td:nth-child(1){
      border-right-color: transparent !important;
    }
  }
}

img{
  vertical-align: middle;
  cursor: pointer;
}
::v-deep .el-table__body-wrapper{
  width: 100%;
  min-height: 400px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}
</style>
